import React from 'react';

function Topbar({ user, pageTitle }) {
  const getInitials = (email) => {
    return email ? email.substring(0, 2).toUpperCase() : 'US';
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        <h4 className="page-title">{pageTitle || 'Dashboard'}</h4>
      </div>
      <div className="topbar-right">
        <div className="user-dropdown">
          <div className="user-avatar">{getInitials(user?.email)}</div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <span style={{ fontSize: '0.875rem', fontWeight: '500', color: 'var(--heading-color)' }}>
              {user?.name || 'User'}
            </span>
            <span style={{ fontSize: '0.75rem', color: 'var(--gray-600)' }}>
              {user?.email}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Topbar;
